import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Eye } from '@phosphor-icons/react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const LoginEventsModal = ({ user, onClose }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const open = !!user;

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    axios
      .get(`${API}/admin/login-events/${user.user_id}`, { withCredentials: true })
      .then((r) => setEvents(r.data.events || []))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, [user]);

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent
        className="max-w-3xl max-h-[85vh] bg-card border-border text-ivory"
        data-testid="login-events-modal"
      >
        <DialogHeader className="shrink-0">
          <DialogTitle className="font-serif text-2xl tracking-tight flex items-center gap-3">
            <Eye size={22} weight="duotone" className="text-gold" />
            Login Events
          </DialogTitle>
          {user && (
            <p className="text-sm text-bone font-sans mt-1">
              <span className="text-ivory">{user.name || 'User'}</span>
              <span className="text-ash"> · {user.email}</span>
            </p>
          )}
        </DialogHeader>

        <div className="flex-1 overflow-y-auto rounded-lg border border-border" data-testid="login-events-list">
          {loading ? (
            <div className="p-8 text-center text-ash text-sm">Loading login history…</div>
          ) : events.length === 0 ? (
            <div className="p-8 text-center text-ash text-sm">No login events recorded for this user.</div>
          ) : (
            <table className="w-full text-sm">
              <thead className="bg-stone border-b border-border sticky top-0">
                <tr>
                  {['When', 'IP', 'Method', 'Device', 'New IP'].map((h) => (
                    <th key={h} className="text-[10px] font-medium uppercase tracking-[0.24em] text-ash p-3 text-left">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {events.map((e) => (
                  <tr key={e.event_id} className="border-t border-border/60 hover:bg-stone/40" data-testid={`login-event-${e.event_id}`}>
                    <td className="p-3 text-xs text-bone tabular-nums whitespace-nowrap">
                      {e.created_at ? new Date(e.created_at).toLocaleString() : '—'}
                    </td>
                    <td className="p-3 text-xs text-ivory font-mono">{e.ip || '—'}</td>
                    <td className="p-3 text-xs">
                      <span className={`px-2 py-0.5 rounded text-[10px] uppercase tracking-wide ${e.method === 'google' ? 'bg-blue-500/15 text-blue-300' : 'bg-stone text-bone'}`}>
                        {e.method || '—'}
                      </span>
                    </td>
                    <td className="p-3 text-[11px] text-bone max-w-[260px] truncate" title={e.user_agent}>{e.user_agent || '—'}</td>
                    <td className="p-3 text-xs">
                      {e.is_new_ip ? (
                        <span className="text-rose-400 font-medium">New</span>
                      ) : (
                        <span className="text-ash">—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="text-[10px] text-ash tracking-wide shrink-0 mt-2">
          Showing up to 200 most recent events · oldest are pruned automatically.
        </div>
      </DialogContent>
    </Dialog>
  );
};
